<template>
    <div class="invoice_manage_wrap" v-loading="loading">
        <div class="aside-left">
            <ul>
                <li
                    v-for="item in statusList.slice(0, 3)"
                    :key="item.id"
                    :class="{ active: status == item.status }"
                    @click="handleClickTypeTab(item)"
                >
                    <i class="iconfont" :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                </li>
            </ul>
            <div class="aside_left_static" v-if="hasUnInvoicePermission">
                <ul>
                    <li
                        v-for="item in statusList.slice(3)"
                        :key="item.id"
                        :class="{ active: status == item.status }"
                        @click="handleClickTypeTab(item)"
                    >
                        <i class="iconfont" :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="content-right">
            <div class="content_right_wrap">
                <div class="page-filter_wrap">
                    <div class="page-filter_wrap_left">
                        <el-input
                            v-model="searchForm.keyword"
                            class="filter-input"
                            clearable
                            placeholder="请输入您想搜索的内容"
                            @clear="handleClickSearch"
                            @keyup.enter.native="handleClickSearch"
                        >
                            <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                        </el-input>
                        <el-popover placement="bottom-start" width="520" trigger="click">
                            <div class="search_container">
                                <div class="search_top_container">
                                    <span class="title">筛选</span>
                                    <el-button
                                        @click="handleClickReset"
                                        size="mini"
                                        :disabled="
                                            searchFilterList.findIndex(
                                                (find) => find.field_value && find.field_value.length > 0
                                            ) > -1
                                                ? false
                                                : true
                                        "
                                        >清空筛选条件</el-button
                                    >
                                </div>
                                <div class="search_bottom_container">
                                    <ul>
                                        <li v-for="item in searchFilterList">
                                            <div>
                                                <el-select size="small" v-model="item.field_key" disabled>
                                                    <el-option label="申请人" value="apply_uid"></el-option>
                                                    <el-option label="申请开票日期" value="apply_time"></el-option>
                                                    <el-option label="财务开票日期" value="invoice_time"></el-option>
                                                    <el-option label="发票类型" value="invoice_type"></el-option>
                                                    <el-option label="驳回日期" value="reject_time"></el-option>
                                                    <el-option label="作废日期" value="invalid_time"></el-option>
                                                    <el-option label="异常状态" value="status"></el-option>
                                                    <el-option label="客户负责人" value="salesperson_uid"></el-option>
                                                </el-select>
                                            </div>
                                            <div class="search_filter_type">
                                                <el-select size="small" v-model="item.field_type" disabled>
                                                    <el-option label="满足" value="eq"></el-option>
                                                    <el-option label="不满足" value="neq"></el-option>
                                                </el-select>
                                            </div>
                                            <div>
                                                <template
                                                    v-if="
                                                        item.field_key == 'apply_uid' ||
                                                        item.field_key == 'salesperson_uid'
                                                    "
                                                >
                                                    <el-select
                                                        v-model="item.field_value"
                                                        :placeholder="'请选择' + item.field_name"
                                                        :remote-method="getUserList"
                                                        filterable
                                                        remote
                                                        size="small"
                                                        multiple
                                                        :multiple-limit="1"
                                                        @change="handleClickSearch"
                                                    >
                                                        <el-option
                                                            v-for="user in userOptions"
                                                            :key="user.uid"
                                                            :label="user.name"
                                                            :value="user.uid"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                                <template
                                                    v-if="
                                                        item.field_key == 'apply_time' ||
                                                        item.field_key == 'invoice_time' ||
                                                        item.field_key == 'reject_time' ||
                                                        item.field_key == 'invalid_time'
                                                    "
                                                >
                                                    <el-date-picker
                                                        v-model="item.field_value"
                                                        end-placeholder="结束时间"
                                                        format="yyyy-MM-dd"
                                                        range-separator="～"
                                                        size="small"
                                                        start-placeholder="开始时间"
                                                        type="daterange"
                                                        value-format="yyyy-MM-dd"
                                                        @clear="item.field_value = []"
                                                        @change="handleClickSearch"
                                                    >
                                                    </el-date-picker>
                                                </template>
                                                <template v-if="item.field_key == 'invoice_type'">
                                                    <el-select
                                                        v-model="item.field_value"
                                                        :placeholder="'请选择' + item.field_name"
                                                        filterable
                                                        size="small"
                                                        multiple
                                                        :multiple-limit="1"
                                                        @change="handleClickSearch"
                                                    >
                                                        <el-option
                                                            v-for="user in invoiceTypeList"
                                                            :key="user.value"
                                                            :label="user.name"
                                                            :value="user.value"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                                <template v-if="item.field_key == 'status'">
                                                    <el-select
                                                        v-model="item.field_value"
                                                        :placeholder="'请选择' + item.field_name"
                                                        filterable
                                                        size="small"
                                                        multiple
                                                        :multiple-limit="1"
                                                        @change="handleClickSearch"
                                                    >
                                                        <el-option
                                                            v-for="user in statusTypeList"
                                                            :key="user.value"
                                                            :label="user.name"
                                                            :value="user.value"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <el-button size="small" slot="reference" class="custom_popover_button">
                                <i class="iconfont icon-shaixuan"></i>
                                <span
                                    class="search_filter_length"
                                    v-if="
                                        searchFilterList.filter(
                                            (find) => find.field_value && find.field_value.length > 0
                                        ).length
                                    "
                                >
                                    <span
                                        v-text="
                                            searchFilterList.filter(
                                                (find) => find.field_value && find.field_value.length > 0
                                            ).length + '个条件'
                                        "
                                    ></span>
                                    <i class="el-icon-error" @click="handleClickReset"></i>
                                </span>
                            </el-button>
                        </el-popover>
                    </div>
                    <div class="page-filter_wrap_right" v-if="hasOperatePermission">
                        <el-button type="primary" plain @click="handleClickExport">导出</el-button>
                        <el-button type="primary" @click="handleClickBatchReject" v-if="status == '1'"
                            >批量驳回</el-button
                        >
                    </div>
                </div>

                <div class="page-content">
                    <CustomVxeTable
                        :ref="'tableRef' + status"
                        :customConfig="tableCustomConfig"
                        :empty-render="{ name: 'NotData' }"
                        :isShowToolBar="true"
                        :pagination.sync="pagination"
                        :reduceHeight="reduceHeight"
                        :tableData="tableData"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        @selection-change="selectionChange"
                    >
                        <template v-if="status == '4'">
                            <vxe-column field="order_num" title="订单编号" min-width="160" show-overflow key="20">
                                <template #default="{ row }">
                                    <span class="link-label" @click="handleClickOrderDetail(row.order_num)">{{
                                        row.order_num
                                    }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="customer_name"
                                title="客户公司名称"
                                min-width="164"
                                show-overflow
                                key="21"
                            >
                                <template #default="{ row }">
                                    <span
                                        class="link-label"
                                        @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                        >{{ row.customer_name }}</span
                                    >
                                </template>
                            </vxe-column>
                            <vxe-column field="contact_info_name" title="客户联系人" width="150" key="22">
                                <template #default="{ row }">
                                    <span>{{ row.contact_info.name }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="customer_user_name" title="客户负责人" width="150" key="23">
                                <template #default="{ row }">
                                    <PersonnelCard
                                        :userId="row.salesperson_info.id"
                                        v-if="row.salesperson_info && row.salesperson_info.id"
                                    >
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="
                                                        row.salesperson_info.avatar
                                                            ? row.salesperson_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span>{{ row.salesperson_info.name }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                </template>
                            </vxe-column>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="total_price"
                                title="订单总金额"
                                min-width="126"
                                show-overflow
                                key="24"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.total_price }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="repay_price"
                                title="实际回款金额"
                                min-width="126"
                                show-overflow
                                key="25"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.repay_price }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="invoiced_amount"
                                title="已开票金额"
                                min-width="126"
                                show-overflow
                                key="26"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.invoiced_amount }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="un_invoice_amount"
                                title="未开票金额"
                                min-width="126"
                                show-overflow
                                key="27"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.un_invoice_amount }}</span>
                                </template>
                            </vxe-column>
                        </template>
                        <template v-else>
                            <vxe-column fixed="left" type="checkbox" width="42" key="1"></vxe-column>
                            <vxe-column field="invoice_no" title="开票编号" min-width="190" key="2">
                                <template #default="{ row }">
                                    <span class="link-label" @click="handleClickInvoiceDetail(row)">{{
                                        row.invoice_no
                                    }}</span>
                                    <el-popover
                                        placement="bottom-start"
                                        title=""
                                        width="500"
                                        trigger="click"
                                        content="关联开票记录"
                                        popper-class="invoice_log_popover"
                                        v-if="row.associated_invoicing_records && row.associated_invoicing_records.length && row.status == 2"
                                    >
                                        <div class="invoice_log_popover_content">
                                            <el-table
                                                :data="row.associated_invoicing_records"
                                                size="small"
                                                border
                                                class="custom_table"
                                                max-height="285"
                                            >
                                                <el-table-column label="开票编号" min-width="200" prop="invoice_no">
                                                    <template slot-scope="{ row }">
                                                        <span
                                                            class="link-label"
                                                            @click="handleClickInvoiceDetail(row)"
                                                            >{{ row.invoice_no }}</span
                                                        >
                                                        <el-tooltip
                                                            v-if="row.invalid_reason"
                                                            popper-class="status_tooltip_item"
                                                            effect="dark"
                                                            :content="row.invalid_reason"
                                                            placement="bottom"
                                                        >
                                                            <span class="handle_icon_wrap handle_icon_wrap_red">
                                                                <i class="iconfont icon-quxiaokaohe"></i>
                                                            </span>
                                                        </el-tooltip>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="开票日期" width="155" prop="time">
                                                    <template slot-scope="{ row }">
                                                        <span>{{ row.confirmed_at }}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    label="开票金额"
                                                    align="right"
                                                    min-width="115"
                                                    prop="invoice_amount"
                                                >
                                                    <template slot-scope="{ row }">
                                                        <span>{{ row.invoice_amount }}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <span
                                            class="handle_icon_wrap handle_icon_wrap_orange"
                                            slot="reference"
                                            style="margin-left: 2px"
                                        >
                                            <i class="iconfont icon-shenpizhong"></i>
                                        </span>
                                    </el-popover>
                                </template>
                            </vxe-column>
                            <vxe-column field="relate_id" title="订单编号" min-width="160" show-overflow key="3">
                                <template #default="{ row }">
                                    <span class="link-label" @click="handleClickOrderDetail(row.relate_id)">{{
                                        row.relate_id
                                    }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="customer_info_name"
                                title="客户公司名称"
                                min-width="164"
                                show-overflow
                                key="4"
                            >
                                <template #default="{ row }">
                                    <span
                                        class="link-label"
                                        @click="
                                            handleClickCustomerDetail(
                                                row.customer_info && row.customer_info.id,
                                                row.customer_info && row.customer_info.name
                                            )
                                        "
                                        >{{ row.customer_info && row.customer_info.name }}</span
                                    >
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="invoice_company_name"
                                title="开票公司名称"
                                min-width="164"
                                show-overflow
                                key="5"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.invoice_company_name }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="contact_info_name" title="客户联系人" width="150" key="6">
                                <template #default="{ row }">
                                    <span>{{ row.contact_info && row.contact_info.name }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="apply_user_name" title="申请人" width="150" key="7">
                                <template #default="{ row }">
                                    <PersonnelCard
                                        :userId="row.apply_user_info.id"
                                        v-if="row.apply_user_info && row.apply_user_info.id"
                                    >
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="
                                                        row.apply_user_info.avatar
                                                            ? row.apply_user_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span>{{ row.apply_user_info.name }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                </template>
                            </vxe-column>
                            <template v-if="status == '3'">
                                <vxe-column field="status" title="异常状态" min-width="178" show-overflow key="8">
                                    <template #default="{ row }">
                                        <span v-if="row.status == 3">已驳回</span>
                                        <span v-else-if="row.status == 4">已作废</span>
                                        <span v-else>--</span>
                                    </template>
                                </vxe-column>
                            </template>
                            <vxe-column field="apply_time" title="申请开票日期" min-width="178" show-overflow key="9">
                                <template #default="{ row }">
                                    <span>{{ row.apply_time }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="invoice_amount"
                                title="申请开票金额"
                                min-width="126"
                                show-overflow
                                key="10"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.invoice_amount }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="invoice_type_name"
                                title="发票类型"
                                min-width="90"
                                show-overflow
                                key="11"
                            >
                                <template #default="{ row }">
                                    <span>{{ row.invoice_type_name }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="invoice_info" title="开票信息" min-width="240" show-overflow key="12">
                                <template #default="{ row }">
                                    <span>{{ row.invoice_info }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="apply_remark" title="备注" min-width="240" show-overflow key="13">
                                <template #default="{ row }">
                                    <span>{{ row.apply_remark }}</span>
                                </template>
                            </vxe-column>
                            <template v-if="status == '2'">
                                <vxe-column
                                    field="confirmed_at"
                                    title="财务开票日期"
                                    min-width="178"
                                    show-overflow
                                    key="14"
                                >
                                    <template #default="{ row }">
                                        <span>{{ row.confirmed_at }}</span>
                                    </template>
                                </vxe-column>
                                <vxe-column
                                    field="invoice_number"
                                    title="发票号"
                                    min-width="240"
                                    show-overflow
                                    key="15"
                                >
                                    <template #default="{ row }">
                                        <el-input
                                            v-if="row.isEditNumber && hasOperatePermission"
                                            class="custom-table_row_input"
                                            v-model="row.invoice_number"
                                            @blur="handleBlur(row)"
                                        ></el-input>
                                        <span v-else @click="handleClickRowEdit(row, 'isEditNumber')">{{ row.invoice_number }}</span>
                                    </template>
                                </vxe-column>
                                <vxe-column
                                    field="finance_remark"
                                    title="财务备注"
                                    min-width="240"
                                    show-overflow
                                    key="16"
                                    cell-class-name="custom-table_row_input_cell"
                                >
                                    <template #default="{ row }">
                                        <el-input
                                            v-if="row.isEditRemark && hasOperatePermission"
                                            class="custom-table_row_input"
                                            v-model="row.finance_remark"
                                            @blur="handleBlur(row)"
                                        ></el-input>
                                        <span v-else @click="handleClickRowEdit(row, 'isEditRemark')">{{ row.finance_remark }}</span>
                                    </template>
                                </vxe-column>
                            </template>
                            <template v-if="status == '3'">
                                <vxe-column field="info" title="操作时间" min-width="240" show-overflow key="17">
                                    <template #default="{ row }">
                                        <span v-if="row.status == 3">{{ row.reject_time }}</span>
                                        <span v-else-if="row.status == 4">{{ row.invalid_time }}</span>
                                        <span v-else>--</span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="remark" title="驳回/作废原因" min-width="240" show-overflow key="18">
                                    <template #default="{ row }">
                                        <template v-if="row.isEditReason">
                                            <el-input
                                                v-if="row.isEditReason && row.status == 3 && hasOperatePermission"
                                                class="custom-table_row_input"
                                                v-model="row.reject_reason"
                                                @blur="handleReasonBlur(row)"
                                            ></el-input>
                                            <el-input
                                                v-if="row.isEditReason && row.status == 4 && hasOperatePermission"
                                                class="custom-table_row_input"
                                                v-model="row.invalid_reason"
                                                @blur="handleReasonBlur(row)"
                                            ></el-input>
                                        </template>
                                        <template v-else>
                                            <span v-if="row.status == 3" @click="handleClickRowEdit(row, 'isEditReason')">{{ row.reject_reason }}</span>
                                            <span v-else-if="row.status == 4" @click="handleClickRowEdit(row, 'isEditReason')">{{ row.invalid_reason }}</span>
                                        </template>
                                    </template>
                                </vxe-column>
                            </template>
                        </template>
                        <vxe-column field="operate" width="90" fixed="right" v-if="status != '4'">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                    <i
                                        class="iconfont icon-biaotoushezhi table-header-icon"
                                        @click="handleClickCustom"
                                    ></i>
                                </el-tooltip>
                            </template>
                            <template #default="{ row }">
                                <el-dropdown placement="bottom-end" trigger="click">
                                    <el-tooltip effect="dark" content="更多" placement="top"
                                        ><i class="iconfont el-icon-more cursor"></i
                                    ></el-tooltip>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            v-if="status == '1' && hasOperatePermission"
                                            @click.native="handleClickInvoiceConfirm(row)"
                                        >
                                            确认
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="status == '1' && hasOperatePermission" @click.native="handleClickReject(row)"
                                            >驳回</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="status == '2' && hasOperatePermission"
                                            @click.native="handleClickInvalidConfirm(row)"
                                        >
                                            作废
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickInvoiceDetail(row)">
                                            详情
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </vxe-column>
                    </CustomVxeTable>
                </div>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :title="handleDialogTitle"
                :visible.sync="handleDialogVisible"
                width="520px"
            >
                <!-- <p class="dialog_label_text">{{ handleDialogTitle }}</p> -->
                <el-input
                    :placeholder="'请输入' + handleDialogTitle"
                    :rows="6"
                    maxlength="200"
                    type="textarea"
                    v-model="handleRemarks"
                >
                </el-input>
                <div align="right" slot="footer">
                    <el-button @click="handleClickCancel" size="small">取消</el-button>
                    <el-button @click="handleClickConfirm" size="small" type="primary">确定</el-button>
                </div>
            </el-dialog>
            <InvoiceConfirmation
                v-if="invoiceConfirmationDialog"
                :invoiceConfirmationDialog.sync="invoiceConfirmationDialog"
                :invoice_no="invoice_no"
                @confirmSuccess="handleClickSearch"
            />
            <InvoiceDetails
                v-if="invoiceDetailsDialog"
                :invoiceDetailsDialog.sync="invoiceDetailsDialog"
                :invoice_no="invoice_no"
                :status="status"
            />
        </div>
    </div>
</template>
<script>
import {
    GetUserList,
    InvoiceList,
    InvoiceReject,
    OrderUnInvoiceList,
    InvoiceExceptionList,
    InvoiceInvalidate,
    InvoiceUpdate,
    UpdateRejectInvalidateReason,
    InvoiceListExport,
    InvoiceExceptionListExport,
    OrderUnInvoiceListExport
} from "@/api";
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import InvoiceConfirmation from "./component/invoice_confirmation.vue";
import InvoiceDetails from "./component/invoice_details.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import * as XLSX from "xlsx";
import {mapGetters} from "vuex";
export default {
    name: "InvoiceManage",
    components: { CustomVxeTable, InvoiceConfirmation, InvoiceDetails, PersonnelCard },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            status: "1", // 分类类型
            statusList: [
                { name: "待开票", status: "1" , icon: "icon-a-daikaipiao1"},
                { name: "已开票", status: "2" , icon: "icon-a-yikaipiao1"},
                { name: "异常开票", status: "3" , icon: "icon-yichangkaipiao"},
                { name: "未开票", status: "4" , icon: "icon-weikaipiao"},
            ], // 应收来源
            searchForm: {
                keyword: "",
            },
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "invoice_no";
                },
                allowSort: true,
            },
            tableData: [],
            selectedList: [],
            // 高级筛选
            searchFilterList: [],
            allSearchFilterList: {
                1: [
                    {
                        field_key: "apply_uid",
                        field_name: "申请人",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "apply_time",
                        field_name: "申请开票日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "invoice_type",
                        field_name: "发票类型",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                        field_value_type: "int", // 判断接口需要的数据格式
                    },
                ],
                2: [
                    {
                        field_key: "apply_uid",
                        field_name: "申请人",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "apply_time",
                        field_name: "申请开票日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "invoice_time",
                        field_name: "财务开票日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "invoice_type",
                        field_name: "发票类型",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                        field_value_type: "int",
                    },
                ],
                3: [
                    {
                        field_key: "apply_uid",
                        field_name: "申请人",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "apply_time",
                        field_name: "申请开票日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "invoice_type",
                        field_name: "发票类型",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                        field_value_type: "int",
                    },
                    {
                        field_key: "reject_time",
                        field_name: "驳回日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "invalid_time",
                        field_name: "作废日期",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "status",
                        field_name: "异常状态",
                        field_value: [],
                        field_value_name: "",
                        field_type: "eq",
                        field_value_type: "int",
                    },
                ],
            },
            // 未开票高级筛选
            unINvoiceSearchFilterList: [
                {
                    field_key: "salesperson_uid",
                    field_name: "客户负责人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
            ],
            userOptions: [],
            invoiceTypeList: [
                { value: 1, name: "电子专票" },
                { value: 2, name: "电子普票" },
                { value: 3, name: "纸质专票" },
                { value: 4, name: "纸质普票" },
            ],
            statusTypeList: [
                { value: 3, name: "已驳回" },
                { value: 4, name: "已作废" },
            ],
            // 开票确认
            invoice_no: "",
            invoiceConfirmationDialog: false,
            // 驳回
            handleDialogTitle: "",
            handleDialogType: "",
            handleDialogVisible: false,
            handleRemarks: "",
            handleDialogIds: [],
            // 详情
            invoiceDetailsDialog: false,
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return this.pagination.total > 0 ? 170 : 170;
        },
        ...mapGetters(['hasPermission']),
        // 未开票权限：进行操作\查看权限；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据未开票的列表权限判断的
        hasUnInvoicePermission() {
            return this.hasPermission('finance.invoice.unInvoiceList', 'finance', 'InvoiceManage');
        },
        // 操作权限：付款、确认、取消、驳回、作废等操作；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据批量驳回的权限判断的
        hasOperatePermission() {
            return this.hasPermission('finance.invoice.rejectBatch', 'finance', 'InvoiceManage');
        },
    },
    created() {
        this.status = (this.$route.query && this.$route.query.status) ? String(this.$route.query.status) : "1";
        this.searchForm.keyword = "";
        this.selectedList = [];
        this.searchFilterList = this.allSearchFilterList[this.status];
        this.handleClickReset();
        this.getUserList();
    },
    methods: {
        handleClickTypeTab(item) {
            this.status = item.status;
            this.searchForm.keyword = "";
            this.selectedList = [];
            if (this.status == 4) {
                // 未开票
                this.searchFilterList = this.unINvoiceSearchFilterList;
            } else {
                this.searchFilterList = this.allSearchFilterList[this.status];
            }
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", []);
            });
            this.handleCurrentChange(1);
        },
        handleClickRowEdit(row, status) {
            this.$set(row, status, true)
        },
         // 防抖
         debounce(func, wait) {
            let timeout;
            return function (...args) {
                const later = () => {
                    timeout = null;
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        // 编辑发票号码和备注
        handleInvoiceUpdate(row) {
            const params = {
                invoice_no: row.invoice_no,
                invoice_number: row.invoice_number,
                finance_remark: row.finance_remark
            }
            if(!params.invoice_no) return;
            InvoiceUpdate(params).then(res=> {
                if(res.code === 200) {
                    this.$message.success("更改成功")
                    this.$set(row, 'isEditRemark', false)
                    this.$set(row, "isEditNumber", false)
                }
            })
        },
        // 编辑驳回/作废原因
        handleRejectInvalidateReasonUpdate(row) {
            let params = {
                invoice_no: row.invoice_no,
                reject_reason: row.reject_reason,
                invalid_reason: row.invalid_reason
            }
            UpdateRejectInvalidateReason(params).then(res=> {
                if(res.code === 200) {
                    this.$message.success("更改成功")
                    this.$set(row, 'isEditReason', false)
                }
            })
        },
        handleBlur(row) {
            this.debounce(this.handleInvoiceUpdate, 300)(row);
        },
        handleReasonBlur(row) {
            this.debounce(this.handleRejectInvalidateReasonUpdate, 300)(row);
        },
        // 表头配置
        handleClickCustom() {
            this.$refs["tableRef" + this.status].handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", []);
            });
            this.handleClickSearch();
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.userOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 搜索
        handleClickSearch() {
            this.pagination.pageNum = 1;
            if (this.status == 1 || this.status == 2) {
                this.getInvoiceList();
            } else if (this.status == 3) {
                this.getInvoiceExceptionList();
            } else {
                this.getOrderUnInvoiceList();
            }
        },
        // 批量驳回
        handleClickBatchReject() {
            if (!this.selectedList.length) return this.$message.error("请选择需要驳回的单据");
            this.handleDialogVisible = true;
            this.handleDialogTitle = "驳回原因";
            this.handleDialogType = "reject";
            this.handleDialogIds = this.selectedList.map((item) => item.invoice_no);
        },
        // 确认
        handleClickInvoiceConfirm(row) {
            this.invoice_no = row.invoice_no;
            this.invoiceConfirmationDialog = true;
        },
        // 单个驳回
        handleClickReject(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "驳回原因";
            this.handleDialogType = "reject";
            this.handleDialogIds = [row.invoice_no];
        },
        // 弹框取消
        handleClickCancel() {
            this.handleDialogVisible = false;
            this.handleDialogTitle = "";
            this.handleRemarks = "";
            this.handleDialogIds = [];
        },
        // 弹框确认
        handleClickConfirm() {
            let error_msg = "请输入" + this.handleDialogTitle;
            if (!this.handleRemarks && this.handleDialogType == "reject") return this.$message.error(error_msg);
            if (this.handleDialogType == "invalid") {
                // 作废
                const params = {
                    invoice_no: this.handleDialogIds[0],
                    invalid_reason: this.handleRemarks,
                };
                InvoiceInvalidate(params).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.selectedList = [];
                                this.handleClickSearch();
                                this.handleClickCancel();
                            },
                        });
                    }
                });
            } else {
                // 驳回
                const params = {
                    invoice_nos: this.handleDialogIds,
                    reject_reason: this.handleRemarks,
                };
                InvoiceReject(params).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.selectedList = [];
                                this.handleClickSearch();
                                this.handleClickCancel();
                            },
                        });
                    }
                });
            }
        },
        // 作废
        handleClickInvalidConfirm(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "作废原因";
            this.handleDialogType = "invalid";
            this.handleDialogIds = [row.invoice_no];
        },
        // 详情
        handleClickInvoiceDetail(row) {
            this.invoice_no = row.invoice_no;
            this.invoiceDetailsDialog = true;
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            if (this.status == 1 || this.status == 2) {
                this.getInvoiceList();
            } else if (this.status == 3) {
                this.getInvoiceExceptionList();
            } else {
                this.getOrderUnInvoiceList();
            }
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            if (this.status == 1 || this.status == 2) {
                this.getInvoiceList();
            } else if (this.status == 3) {
                this.getInvoiceExceptionList();
            } else {
                this.getOrderUnInvoiceList();
            }
        },
        // 待开票和已开票列表
        getInvoiceList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                status: this.status,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value && item.field_value.length) {
                    params[item.field_key] =
                        item.field_value_type && item.field_value_type == "int"
                            ? item.field_value[0]
                            : item.field_value;
                }
            });
            InvoiceList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                    this.$nextTick(()=> {
                        this.getMessageNoticeData()
                    })
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 未开票列表
        getOrderUnInvoiceList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value && item.field_value.length) {
                    params[item.field_key] =
                        item.field_value_type && item.field_value_type == "int"
                            ? item.field_value[0]
                            : item.field_value;
                }
            });
            OrderUnInvoiceList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 异常开票列表（已驳回、已作废）
        getInvoiceExceptionList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value && item.field_value.length) {
                    params[item.field_key] =
                        item.field_value_type && item.field_value_type == "int"
                            ? item.field_value[0]
                            : item.field_value;
                }
            });
            InvoiceExceptionList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 消息通知开票编号选中
        getMessageNoticeData() {
            const invoice_no = this.$route.query && this.$route.query.invoice_no;
            const selectedList = this.tableData.filter(item=> item.invoice_no === invoice_no)
            this.selectedList = selectedList
        },
        // 导出
        handleClickExport() {
            this.loading = true;
            if (this.status == 1 || this.status == 2) {
                let params = {
                    page: 1,
                    pageSize: this.pagination.total,
                    status: this.status,
                    keyword: this.searchForm.keyword,
                };
                this.searchFilterList.forEach((item) => {
                    if (item.field_value && item.field_value.length) {
                        params[item.field_key] =
                            item.field_value_type && item.field_value_type == "int"
                                ? item.field_value[0]
                                : item.field_value;
                    }
                });
                InvoiceListExport(params)
                    .then((res) => {
                        if (res.code == 200) {
                            const { data, total } = res.data;
                            this.xlsxToExcel(data);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else if (this.status == 3) {
                let params = {
                    page: 1,
                    pageSize: this.pagination.total,
                    keyword: this.searchForm.keyword,
                };
                this.searchFilterList.forEach((item) => {
                    if (item.field_value && item.field_value.length) {
                        params[item.field_key] =
                            item.field_value_type && item.field_value_type == "int"
                                ? item.field_value[0]
                                : item.field_value;
                    }
                });
                InvoiceExceptionListExport(params)
                    .then((res) => {
                        if (res.code == 200) {
                            const { data, total } = res.data;
                            this.xlsxToExcel(data);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                let params = {
                    page: 1,
                    pageSize: this.pagination.total,
                    keyword: this.searchForm.keyword,
                };
                this.searchFilterList.forEach((item) => {
                    if (item.field_value && item.field_value.length) {
                        params[item.field_key] =
                            item.field_value_type && item.field_value_type == "int"
                                ? item.field_value[0]
                                : item.field_value;
                    }
                });
                OrderUnInvoiceListExport(params)
                    .then((res) => {
                        if (res.code == 200) {
                            const { data, total } = res.data;
                            this.xlsxToExcel(data);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        xlsxToExcel(exportData) {
            let tableData = [];
            let fields_list = [];
            const status = this.status;
            if (status == "4") {
                fields_list = [
                    { field_key: "order_num", field_name: "订单编号" },
                    { field_key: "customer_name", field_name: "客户公司名称" },
                    { field_key: "name", p_Field_key: "contact_info", field_name: "客户联系人" },
                    { field_key: "name", p_Field_key: "salesperson_info", field_name: "客户负责人" },
                    { field_key: "total_price", field_name: "订单总金额" },
                    { field_key: "repay_price", field_name: "实际回款金额" },
                    { field_key: "invoiced_amount", field_name: "已开票金额" },
                    { field_key: "un_invoice_amount", field_name: "未开票金额" },
                ];
            } else {
                fields_list = [
                    { field_key: "invoice_no", field_name: "开票编号" },
                    { field_key: "relate_id", field_name: "订单编号" },
                    { field_key: "name", p_Field_key: "customer_info", field_name: "客户公司名称" },
                    { field_key: "invoice_company_name", field_name: "开票公司名称" },
                    { field_key: "name", p_Field_key: "contact_info", field_name: "客户联系人" },
                    { field_key: "name", p_Field_key: "apply_user_info", field_name: "申请人" },
                ];
                if (status == "3") {
                    fields_list.push({
                        field_key: "status",
                        field_name: "异常状态",
                    });
                }
                fields_list = fields_list.concat([
                    { field_key: "apply_time", field_name: "申请开票日期" },
                    { field_key: "invoice_amount", field_name: "申请开票金额" },
                    { field_key: "invoice_type_name", field_name: "发票类型" },
                    { field_key: "invoice_info", field_name: "开票信息" },
                    { field_key: "apply_remark", field_name: "备注" },
                ]);
                if (status == "2") {
                    fields_list = fields_list.concat([
                        { field_key: "confirmed_at", field_name: "财务开票日期" },
                        { field_key: "invoice_number", field_name: "发票号" },
                        { field_key: "finance_remark", field_name: "财务备注" },
                    ]);
                }
                if (status == "3") {
                    fields_list = fields_list.concat([
                        { field_key: "custom_operate_time", field_name: "操作时间" },
                        { field_key: "custom_operate_reason", field_name: "驳回/作废原因" },
                    ]);
                }
            }

            tableData = exportData.map((row) => {
                const itemdata = {};
                fields_list.forEach((field) => {
                    if (status == "3") {
                        if (field.field_key == "custom_operate_time") {
                            itemdata[field.field_name] =
                                row.status == 3 ? row.reject_time : row.status == 4 ? row.invalid_time : "--";
                        } else if (field.field_key == "custom_operate_reason") {
                            itemdata[field.field_name] =
                                row.status == 3 ? row.reject_reason : row.status == 4 ? row.invalid_reason : "--";
                        } else if (field.field_key == "status") {
                            itemdata[field.field_name] = row.status == 3 ? "已驳回" : row.status == 4 ? "已作废" : "--";
                        } else {
                            itemdata[field.field_name] = field.p_Field_key
                                ? row[field.p_Field_key]?.[field.field_key]
                                : row[field.field_key];
                        }
                    } else {
                        itemdata[field.field_name] = field.p_Field_key
                            ? row[field.p_Field_key]?.[field.field_key]
                            : row[field.field_key];
                    }
                });
                return itemdata;
            });

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tableData);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = this.nowDate();
            XLSX.writeFile(wb, fileName);
        },
        nowDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            const statusName = this.statusList.find((item) => item.status == this.status)?.name;
            return `${statusName}-${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 查看订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.invoice_manage_wrap {
    width: 100%;
    height: 100%;
    display: flex;

    .aside-left {
        width: 196px;
        flex-shrink: 0;
        padding: 12px 8px;

        ul {
            li {
                width: 100%;
                padding: 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                color: rgba(102, 102, 102, 100);
                border-radius: 4px;
                font-weight: 400;

                span {
                    font-size: 14px;
                    letter-spacing: 0px;
                    line-height: 22px;
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
                &.active {
                    background: rgba(41, 144, 255, 0.16);
                    font-weight: 700;
                    color: #2990ff;
                }
            }
        }
    }
    .aside_left_static {
        position: relative;
        margin-top: 8px;
        padding-top: 8px;
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 3px;
            right: 3px;
            height: 1px;
            background-color: rgba(232, 232, 232, 1);
        }
    }

    .content-right {
        flex: 1;
        border-left: 1px solid rgba(232, 232, 232, 1);
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .content_right_wrap {
            flex: 1;
            padding: 16px;
        }
    }
    .handle_icon_wrap_orange {
        .iconfont {
            color: #f0aa32;
        }
    }
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div:nth-child(1),
                & > div:nth-child(2) {
                    flex: 1;
                }
                & > div:nth-child(3) {
                    width: 225px;
                    flex-shrink: 0;
                    .el-select {
                        width: 100%;
                    }
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
}
.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
</style>
<style lang="scss">
.invoice_log_popover {
    padding: 16px;
    .handle_icon_wrap_red {
        margin-left: 4px;
        .iconfont {
            color: rgba(228, 65, 68, 1);
        }
    }
}
.status_tooltip_item {
    max-width: 420px;
    white-space: normal;
    word-wrap: break-word;
}
.custom-table_row_input {
    input {
        border: 0;
        &:focus {
            border: 1px solid rgba(41, 144, 255, 0.5);
        }
    }
}
</style>
